import React from 'react';
import { createStyles, Group, Text } from '@mantine/core';
import useIsMounted from '@hooks/use-is-mounted';
import { useBookingState } from "@core/providers/BookingStateProvider";


const useStyles = createStyles((theme: {
    colors: { [x: string]: any[] };
    white: string;
    fontSizes: any;
    spacing: any;
    radius: any;
    fn: any;
    black: any;
    shadows: any;
    colorScheme: string;
}) => ({

    priceGroup: {
        // width: '100%',
    },

    priceCurrency: {
        marginBottom: 0,
        position: 'relative',
        bottom: 13,
        fontSize: 16,
        fontWeight: 400,
        marginRight: 4,
    },

    priceAmount: {
        marginBottom: 0,
        marginTop: 0,
        fontSize: 36,
        textAlign: 'center',
        fontWeight: 400,
    },

    priceDuration: {
        marginTop: 0,
        position: 'relative',
        top: 4,
        fontSize: 20,
        fontWeight: 400,
    },

}));


export const PricePerNight: React.FC = () => {

    const { classes } = useStyles();
    const isMounted = useIsMounted();

    const { priceCalculations } = useBookingState();

    return isMounted && (
        <Group className={classes.priceGroup}>
            <Text style={{ flex: 2 }}>
                <span className={classes.priceCurrency}>AED</span>
                <span className={classes.priceAmount}>{priceCalculations.pricePerNight}</span>
                <span className={classes.priceDuration}>/ night</span>
            </Text>

        </Group>
    )

}
